import React from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { ReactComponent as ChevronRightSVG } from "go-core/images/svg/actions/preview-arrow.svg";
import { ReactComponent as ChargeBeeSVG } from "../../../../../../images/svg/organization/chargebee.svg";
import { ReactComponent as IntercomSVG } from "../../../../../../images/svg/organization/intercom.svg";
import { OrganizationIntegrationApi } from "../../../../../../services/Api/Admin/adminTypes";

interface Props {
	integrations: OrganizationIntegrationApi[];
}

const OrganizationIntegrationsCard = ({ integrations }: Props) => {
	const { t } = useTranslation("admin");

	const drawIntegrationLogo = (integration: OrganizationIntegrationApi) => {
		switch (integration.name) {
			case "INTERCOM":
				return <IntercomSVG />;
			case "CHARGEBEE":
				return <ChargeBeeSVG />;
			default:
				return <></>;
		}
	};

	return (
		<Card>
			<Card.Body>
				<h5>{t("modules.organization.field.integrations.title")}</h5>
				{integrations.map((integration, index) => (
					<div className="card-body-item justify-content-between" key={`organization-integration-${index}`}>
						<div className="d-flex align-items-center">
							{drawIntegrationLogo(integration)}
							<span>{t(`enums.organization.integration.${integration.name}`)}</span>
						</div>
						<a className="btn btn-light p-1" href={`${integration.url}`} target="_blank" rel="noreferrer">
							<ChevronRightSVG className="me-0" />
						</a>
					</div>
				))}
			</Card.Body>
		</Card>
	);
};
export default OrganizationIntegrationsCard;

// t(`enums.organization.integration.INTERCOM`);
// t(`enums.organization.integration.CHARGEBEE`);
